import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProductShipmentDto, ProductShipmentStatus, UpdateProductShipmentDto } from '../../common/general-types/briefs.dto';

@Injectable({ providedIn: 'root' })
export class ProductShipmentService {
  private http = inject(HttpClient);
  private base = `${environment.shout_api.url}/product-shipments`;

  getByBrief(briefId: string, status?: ProductShipmentStatus | null, search?: string): Observable<ProductShipmentDto[]> {
    const params: Record<string, string> = {};
    if (status) params['status'] = status;
    if (search?.trim()) params['search'] = search.trim();
    return this.http.get<ProductShipmentDto[]>(`${this.base}/by-brief/${briefId}`, { params });
  }

  getOne(id: string): Observable<ProductShipmentDto> {
    return this.http.get<ProductShipmentDto>(`${this.base}/${id}`);
  }

  update(id: string, dto: UpdateProductShipmentDto): Observable<ProductShipmentDto> {
    return this.http.patch<ProductShipmentDto>(`${this.base}/${id}`, dto);
  }
}
